module.exports = __webpack_public_path__ + "img/gr.471d733a.svg";